module.exports = __webpack_public_path__ + "media/components/src/assets/images/arrow-book-detail/arrow-right-5c2b6f578c75b5150ee7c431bec8b1aa.svg";